import { supabase } from '../supabase';

/**
 * Get the current user's company_id
 * This is used to automatically inject company_id into create mutations
 * to satisfy RLS policies
 */
export async function getCurrentUserCompanyId(): Promise<string> {
  // No-arg RPC overload resolves the effective user server-side via
  // effective_user_id(), so impersonation works automatically. Passing
  // auth.getUser().id here would break impersonation: getUser returns the
  // superadmin, not the impersonated user, so we would scope queries to
  // the wrong company. See migration 20260528140000.
  const { data, error } = await supabase.rpc('get_user_company_member');

  if (error) {
    throw new Error('User not assigned to a company');
  }

  const row = Array.isArray(data) ? data[0] : data;
  if (!row) {
    throw new Error('User not assigned to a company');
  }

  return row.company_id;
}

/**
 * Inject company_id into data object for create mutations
 */
export async function withCompanyId<T>(data: T): Promise<T & { company_id: string }> {
  const company_id = await getCurrentUserCompanyId();
  return {
    ...data,
    company_id,
  };
}
